<i18n>
{
  "en": {
    "create-shop": "Create Shop",
    "step-1-of-3": "Step 1 of 3"
  },
  "th": {
    "create-shop": "สร้างร้านค้า",
    "step-1-of-3": "ขั้นตอนที่ 1 จาก 3"
  }
}
</i18n>
<template>
  <v-dialog
    v-model="showCreateShopDialog"
    fullscreen
    hide-overlay
    transition="slide-fade"
    scrollable
  >
    <v-container
      class="fill-height pt-12 dialog-background"
      fluid
    >
      <v-row
        align="start"
        justify="start"
        class="fill-height pt-12"
      >
        <v-col
          cols="12"
          sm="8"
          md="8"
          lg="5"
          xl="1"
        >
        </v-col>
        <v-col
          cols="12"
          sm="8"
          md="8"
          lg="5"
          xl="4"
        >
          <div>
            <v-btn
              icon
               class="pr-5"
              @click="closeCreateShopDialog()"
            >
              <v-icon>mdi-close</v-icon>
            </v-btn>
            <span class="title grey--text text--darken-1 font-weight-light">
              {{ $t('create-shop')}}({{ $t('step-1-of-3') }})
            </span>
            <div class="mb-12"></div>
            <div class="pt-12">
              <span class="display-1">เริ่มจากเลือกเพจก่อนเลย</span>
            </div>
          </div>
        </v-col>

      </v-row>
    </v-container>
  </v-dialog>
</template>

<script>
import helpers from '../../mixins/helpers'
import { mapState, mapMutations } from 'vuex'

export default {
  name: 'TheCreateShopDialog',
  mixins: [helpers],
  data () {
    return {
      dialog: false
    }
  },
  methods: {
    ...mapMutations([
      'shop/setShowCreatShopDialog'
    ]),
    closeCreateShopDialog () {
      this['shop/setShowCreatShopDialog'](false)
    }
  },
  computed: {
    ...mapState({
      showCreateShopDialog: state => state.shop.showCreatShopDialog
    })
  }
}
</script>

<style>
  .dialog-background {
    background: linear-gradient(90deg, #F6F7F9 82%, rgba(240, 143, 68, 1) 0%);
  }
</style>
